import React from 'react';
import { RxMagnifyingGlass } from 'react-icons/rx';
import { components } from 'react-select';

export function NoOptionsMessage(props) {
	const { selectProps } = props;
	const { name, handleSetOutOfPocket, locationContainerDisclaimer } =
		selectProps;

	const handleClick = (e) => {
		e.preventDefault();
		handleSetOutOfPocket();
	};

	return (
		<>
			<components.NoOptionsMessage {...props}>
				{locationContainerDisclaimer ? (
					<div className='location-container-disclaimer'>
						{locationContainerDisclaimer}
					</div>
				) : (
					<div className='as' style={{ lineHeight: '21px' }}>
						{name === 'services' && <p>Location not found</p>}
						{name === 'insurance' && (
							<>
								<p
									className='pb05 '
									style={{ color: '#332F2E' }}
								>
									Don&apos;t see your insurance provider?
								</p>
								<span style={{ color: '#7B756F' }}>
									We&apos;re always working to add more
									payment options. Explore out-of-pocket
									options or
									<a
										className='cbb'
										href={
											'https://alma-help.zendesk.com/hc/en-us/articles/4408054867867-How-to-pay-for-therapy-without-insurance-coverage'
										}
									>
										&nbsp;learn more about paying for
										therapy without insurance coverage.
									</a>
								</span>
								<div
									className='no-payment-search cgr f my025 pointer'
									onClick={handleClick}
								>
									<div className='f aic pr05 '>
										<RxMagnifyingGlass className='cgrn' />
									</div>

									<h5 className='cgrn'>
										Search for out-of-pocket-care
									</h5>
								</div>
							</>
						)}
						{name === 'sessionTypes' && (
							<p>Session type not found</p>
						)}
						{name === 'locations' && <p>Location not found</p>}
						{!name && <p>Not found</p>}
					</div>
				)}
			</components.NoOptionsMessage>
		</>
	);
}
